import BusinessIcon from "@mui/icons-material/Business";
import FactoryIcon from "@mui/icons-material/Factory";
import CategoryIcon from "@mui/icons-material/Category";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";

import LocationCityIcon from "@mui/icons-material/LocationCity";
import MapIcon from "@mui/icons-material/Map";
import PublicIcon from "@mui/icons-material/Public";

import LanguageIcon from "@mui/icons-material/Language";
import PeopleIcon from "@mui/icons-material/People";
import DescriptionIcon from "@mui/icons-material/Description";
import { Box, Typography } from "@mui/material";
import { getSectorDisplayParts } from "../../constants/sectors";

const BRAND_BLUE = "#00336C";

/* ---------------- Formatting ---------------- */

const formatEmployees = (val) =>
  val != null ? Number(val).toLocaleString() : "—";

const formatNAICS = (company) => {
  if (company.naics_name) return company.naics_name;
  if (company.primary_naics_bucket) return company.primary_naics_bucket;

  return "—";
};

/* ---------------- Profile Config ---------------- */

export function prospectingCompanyProfileConfig(company = {}) {
  const sectorDisplay = getSectorDisplayParts(company.sector);
  const naicsDisplay = formatNAICS(company);

  return [
    {
      title: "Company Information",
      rows: [
        {
          icon: <BusinessIcon />,
          label: "Company Name",
          value: company.name || "—",
        },
        {
          icon: <FactoryIcon />,
          label: "Sector",
          value: sectorDisplay.standardizedSector ? (
            <Box>
              <Typography sx={{ fontWeight: 600 }}>
                {sectorDisplay.standardizedSector}
              </Typography>
              {sectorDisplay.showRawSector && (
                <Typography sx={{ color: "text.secondary", fontSize: "0.85rem" }}>
                  {sectorDisplay.rawSector}
                </Typography>
              )}
            </Box>
          ) : "—",
          showIf: Boolean(company.sector),
        },
        {
          icon: <FormatListBulletedIcon />,
          label: "NAICS Text",
          value: naicsDisplay,
          showIf: naicsDisplay !== "—",
        },
        {
          icon: <CategoryIcon />,
          label: "NAICS Code",
          value: company.naics_code || "—",
          showIf: Boolean(company.naics_code),
        },
        {
          icon: <PeopleIcon />,
          label: "Employees",
          value: formatEmployees(company.number_of_employees),
          showIf: Boolean(company.number_of_employees),
        },
        {
          icon: <CategoryIcon />,
          label: "Industries Served",
          value: company.industries_served || "—",
          showIf: Boolean(company.industries_served),
        },
        {
          icon: <PublicIcon />,
          label: "Geographic Markets Covered",
          value: company.geographic_markets_covered || "—",
          showIf: Boolean(company.geographic_markets_covered),
        },
        {
          icon: <LanguageIcon />,
          label: "Website",
          value: company.website ? (
            <a
              href={
                company.website.startsWith("http")
                  ? company.website
                  : `https://${company.website}`
              }
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: BRAND_BLUE,
                fontWeight: 600,
                textDecoration: "none",
              }}
            >
              {company.website}
            </a>
          ) : (
            "—"
          ),
          showIf: Boolean(company.website),
        },
        {
          icon: <DescriptionIcon />,
          label: "Description",
          value: company.description || "—",
          showIf: Boolean(company.description),
        },
      ],
    },

    {
      title: "Location",
      rows: [
        {
          icon: <PublicIcon />,
          label: "Country",
          value: company.country || "—",
          showIf: Boolean(company.country),
        },
        {
          icon: <MapIcon />,
          label: "State / Province",
          value: company.state || "—",
          showIf: Boolean(company.state),
        },
        {
          icon: <LocationCityIcon />,
          label: "City",
          value: company.city || "—",
          showIf: Boolean(company.city),
        },
        {
          icon: <MapIcon />,
          label: "County",
          value: company.county || "—",
          showIf: Boolean(company.county),
        },
      ],
    },
  ];
}
